import React, { ComponentProps } from 'react';
import { TypeListItem } from '@spotify-internal/encore-web';

const StepListItem = (props: ComponentProps<typeof TypeListItem>) => (
  <TypeListItem variant="ballad" {...props} />
);

export default StepListItem;
